class EventItems extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    const items = Array.from(this.els.item.elements)

    items.sort((a, b) => {
      const dateA = parseInt(a.dataset.date) || 0
      const dateB = parseInt(b.dataset.date) || 0
      return dateA - dateB
    })

    items.forEach((item) => this.appendChild(item))
  }
}

if (!customElements.get('event-items')) {
  customElements.define('event-items', EventItems)
}
